export const formattedHashtags = (rawHashtags: string[], includeDefaults: boolean = true) => {
  const hashtags = [...new Set(rawHashtags)]

  if (includeDefaults) {
    hashtags.unshift('gifted')
    hashtags.unshift('localfluence')
  }

  return hashtags.map((elem) => '#' + elem).join(', ')
}

export const formattedMentions = (rawMentions: string[]) => {
  const mentions = [...new Set(rawMentions)]

  return mentions.map((elem) => '@' + elem).join(', ')
}
